import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import {
  Popover,
  PopoverContent,
  PopoverTriggerButton,
} from '../../../../CommonComponents/OPL/Popover/Popover';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';

interface Props extends WrapperProps {
  estimatedValue: number;
  riskScore: number | null;
  estimatedValueYear: number;
}

export const SummaryTable: React.FC<Props> = ({
  estimatedValue,
  //  Currently, this calculation is broken.
  //  BE is working on it -> https://dev.azure.com/orionadvisor/Orion%20Agile/_workitems/edit/117816
  // riskScore,
  estimatedValueYear,
}) => {
  return (
    <Box border="1px solid" borderColor="neutral.200" borderRadius="medium" display="flex" mb="24">
      <Box
        display="flex"
        flexDirection="column"
        borderRight="1px solid"
        borderColor="neutral.200"
        flex={1}
        p="24"
      >
        <Text variant="smallCaps">
          Estimated value in {estimatedValueYear}{' '}
          <Popover>
            <PopoverTriggerButton aria-label="Info">
              <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
            </PopoverTriggerButton>

            <PopoverContent side="top" width={270} p="16">
              <Text fontWeight={500} textAlign="left" mb="4">
                How is Estimated Value calculated?
              </Text>
              <Text color="neutral.500" textAlign="left">
                This estimated value is based on your starting investment, monthly contributions,
                the growth rate of the model portfolio you are considering and length of time until
                you start taking withdrawals.
              </Text>
            </PopoverContent>
          </Popover>
        </Text>

        <Text variant="tabular" fontSize="h1" fontWeight={600}>
          {formatCurrency(estimatedValue)}
        </Text>
      </Box>

      {/*
        Currently, this calculation is broken.
        BE is working on it -> https://dev.azure.com/orionadvisor/Orion%20Agile/_workitems/edit/117816

      <Box display="flex" flexDirection="column" p="24" alignItems="center">
        <Text variant="smallCaps">Risk score</Text>
        <Text variant="tabular" fontSize="h1" fontWeight={600}>
          {riskScore || '-'}
        </Text>
      </Box>
      */}
    </Box>
  );
};
